module.exports = __webpack_public_path__ + "fba5f23370dc97d70b8a5d40df302772.png";